import { render, staticRenderFns } from "./DisciplineSelector.vue?vue&type=template&id=b6bb2c50&scoped=true"
import script from "./DisciplineSelector.vue?vue&type=script&lang=js"
export * from "./DisciplineSelector.vue?vue&type=script&lang=js"
import style0 from "./DisciplineSelector.vue?vue&type=style&index=0&id=b6bb2c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bb2c50",
  null
  
)

export default component.exports